export enum InsuranceContractChannel {
  CREATE = 'insuranceContract::create',
  EDIT = 'insuranceContract::patch',
  DELETE = 'insuranceContract::delete',
}
